import { render } from "./VoiceCallPanel.vue?vue&type=template&id=3a031497&scoped=true"
import script from "./VoiceCallPanel.vue?vue&type=script&lang=js"
export * from "./VoiceCallPanel.vue?vue&type=script&lang=js"

import "./VoiceCallPanel.vue?vue&type=style&index=0&id=3a031497&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a031497"]])

export default __exports__